/*
 * Lib Module Popups
 */

class Popup extends LibModule {
    DOMReady() {
        this.bindConfirms();
        this.bindAlerts();
        this.bindPopups();
    }

    bindConfirms() {
        $(document).on('click', '[data-confirm]', function(e) {
            var el = $(this);

            if (!el.data('isConfirmed')) {
                e.preventDefault();

                let confirm = $(this).data('confirm');

                // Defaults
                let title = 'Weet je dit zeker?';
                let text = $(this).data('confirm-title') || 'Weet je zeker dat je door wilt gaan?';
                let buttonYesText = 'Ja';
                let buttonNoText = 'Nee';
                let color = 'blue';

                // If confirm is an option object
                if (typeof confirm === 'object') {
                    title = Lib.Hash.get(confirm, 'title', title);
                    text = Lib.Hash.get(confirm, 'text', text);
                    buttonYesText = 'button-yes' in confirm ? confirm['button-yes'] : buttonYesText;
                    buttonNoText = 'button-no' in confirm ? confirm['button-no'] : buttonNoText;
                    color = Lib.Hash.get(confirm, 'color', color);
                } else {
                    text = confirm;
                }

                let buttons = {};

                if (buttonYesText) {
                    buttons[buttonYesText] = {
                        color: 'red',
                        onClick: function() {
                            Lib.Modal.close();

                            // If its a postlink, make a form and submit it
                            if (el.data('postlink')) {
                                Lib.Loader.show();
                                Lib.Postlink.launch(el);
                            } else {
                                // Else, we check what tag we have and determine what to do
                                let tag = el.prop('tagName').toLowerCase();
                                if (tag === 'a') {
                                    Lib.Util.redirect(el.attr('href'), false, false, (el.attr('target') === '_blank'));
                                } else {
                                    el.data('isConfirmed', true);
                                    el.click();
                                    el.data('isConfirmed', false);
                                }
                            }
                        }
                    };
                }

                if (buttonNoText) {
                    buttons[buttonNoText] = {
                        color: 'blue',
                        close: true
                    };
                }

                Lib.Modal.confirm({
                    title: title,
                    content: text,
                    color: color,
                    buttons: buttons
                });
            }

        });
    }

    bindAlerts() {
        $(document).on('click', '[data-alert]', function() {
            Lib.Modal.alert({
                title: 'Oeps!',
                content: $(this).data('alert') || ''
            });
        });
        $(document).on('click', '[data-alert-once]', function() {
            if ($(this).data('prevent-popup') !== true) {
                $(this).data('prevent-popup', true);
                Lib.Modal.alert({
                    title: 'Oeps!',
                    content: $(this).data('alert-once') || ''
                });
            }
        });
    }

    bindPopups() {
        $(document).on('click', '[data-popup]', function(e) {
            if ($(this).data('prevent-submit')) {
                e.preventDefault();
            }
            Lib.Modal.popup({
                title: 'Melding van Corpoflow',
                content: $(this).data('popup') || ''
            });
        });

        $(document).on('click', '[data-popup-once]', function() {
            if ($(this).data('prevent-popup') !== true) {
                $(this).data('prevent-popup', true);
                Lib.Modal.popup({
                    title: 'Melding van Corpoflow',
                    content: $(this).data('popup-once') || ''
                });
            }
        });
    }
}

Lib.Popup = new Popup;
